let dieCutSuccess = true;
function getExtractDieCutData(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, prevLineType, noclearImg, beClear) {
    if(productType_ && productType_ != '' && productType_ != 'sticker'){
        productType_ = productType_.replace(/\s+/g, "");
    }else{
        productType_ = 'sticker';
        if($('.product__titleh1').text().indexOf('sticker') == -1 && $('.product__titleh1').text().indexOf('Stickers') == -1){
            productType_ = '';
        }
    }
    let dieCutData
    if(beClear && dieCutResultData.clearData){
      dieCutData = dieCutResultData.clearData
    } else if(!beClear && dieCutResultData.data){
      dieCutData = dieCutResultData.data
    }
    if(dieCutData) {
      initCanvasDieCut(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, dieCutData, beClear);
      return
    }
    let data = {
        productType: productType_,
        imgPath: drawImageUrl.replace(new RegExp('!.*'), ''),
        width: inchWidth,
        height: inchHeight,
    };
    var resData = {
      img_data: drawImageUrl,
      outlineDist: 0,
      bleedDist: 0,
      coord_pix: [0, 0, inchWidth * 300, inchHeight * 300]
    };
    //Cannot die cut beyond the specified size
    if(imgFactWidth > 4096 || imgFactHeight > 4096) {
      $('.cartreloads').css('display','none');
      dieCutError(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, prevLineType, noclearImg, resData, beClear);
      return
    }
    $('.cartreloads').find('p').text('Loading your design...');
    $('.cartreloads').css('display','block');
    $.ajax({
        url: "https://diy.racetopprint.com/racetop-produce/api/aliendiecut/extractDieCutLine",
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function(res) {
          isInstructionsTip=false
            $('.cartreloads').css('display','none');
            if (res.success) {
              dieCutSuccess = true;
              resData = res.data;
              initCanvasDieCut(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, resData, beClear);
            } else {
              dieCutError(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, prevLineType, noclearImg, resData, beClear);
            }
        },
        error: function(error) {
              $('.cartreloads').css('display','none');
              dieCutError(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, prevLineType, noclearImg, resData, beClear);
        }
    });
}
function dieCutError(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, prevLineType, noclearImg, resData, beClear) {
    dieCutSuccess = false;
    if(noclearImg) {
      drawImageUrl = noclearImg
      $('.become-clearer').removeClass('on');
    }
    initCanvasDieCut(inchWidth, inchHeight, drawImageUrl, imgFactWidth, imgFactHeight, uniqueId, lineType, productType_, resData, beClear);
    $('.InstructionsTip1').css('display','block')
    //reSetSelect(prevLineType);
}
function reSetSelect(prevLineType) {
  if(prevLineType){
    $('.ShapeselectionDiy button[line-type="'+prevLineType+'"]').parent().addClass('active').siblings().removeClass('active');
  } else {
    $('.uploadPropTipDiy').css('display','none')
    $('.uploadProp').css('display','block')
  }
}
function initCanvasDieCut(a, b, c, d, e, f, g, h, dieCutData, beClear) {
    circlesticker = 'dieCut'
    $('.uploadShape').val('Die cut');
    btnShowOrHide(false, true)
    $('.canvas-container').remove();
    $(".page-width .paper-handbag-Diy").remove();
    inchWidth = a;
    inchHeight = b;
    drawImageUrl = c;
    imgFactWidth = d;
    imgFactHeight = e;
    uniqueId = f;
    lineType = 'dieCut';
    if(h){
       productType = h;
    }

    if(beClear){
      dieCutResultData.clearData = dieCutData
    } else {
      dieCutResultData.data = dieCutData
    }
    let imageStr = dieCutData.img_data, svgStr = dieCutData.svg_data, outlineDist = dieCutData.outlineDist, bleedBase = dieCutData.bleedDist, coords = dieCutData.coord_pix;
    let canvasId = "cas-res";
    var existingCanvas = document.getElementById(canvasId);
    if(!existingCanvas) {
        $('.uploadPropTipDiy .can-resource').append('<canvas id="cas-res" ></canvas>');
        canvasSource = new fabric.Canvas(canvasId);
    } else {
        canvasSource = new fabric.Canvas(existingCanvas);
        canvasSource.clear();
    }
    var expansionDistance = 2 * (outlineDist + bleedBase);
    workAreaWidth = inchWidth * 25.4 + expansionDistance,
    workAreaHeight = inchHeight * 25.4 + expansionDistance;
    let realLeft = coords[0], realTop = coords[1], realWidth = coords[2] - realLeft, realHeight = coords[3] - realTop;
    if (window.document.body.clientWidth < 750){
        diyWorkAreaWidth = $(window).width() * 0.95 - 80;
        diyWorkAreaHeight = diyWorkAreaWidth
    }else{
        diyWorkAreaWidth = canvasInitSize;
        diyWorkAreaHeight = canvasInitSize;
    }
    let canvasScale = 1;
    if(workAreaWidth > workAreaHeight){
        canvasScale = diyWorkAreaWidth / workAreaWidth;
        diyWorkAreaHeight = workAreaHeight * canvasScale;
    }else{
        canvasScale = diyWorkAreaHeight / workAreaHeight;
        diyWorkAreaWidth = workAreaWidth * canvasScale;
    }
    let outlineDistWidth = outlineDist * canvasScale, outlineDistHeight = outlineDist * canvasScale;
    secondBleedWidth = bleedBase * canvasScale, secondBleedHeight = bleedBase * canvasScale;
    let showCanvasWidth = diyWorkAreaWidth, showCanvasHeight = diyWorkAreaHeight;
    if(realWidth > realHeight){
        showCanvasHeight = realHeight * showCanvasWidth / realWidth;
    }else{
        showCanvasWidth = realWidth * showCanvasHeight / realHeight;
    }
    canvasSource.setWidth(showCanvasWidth);
    canvasSource.setHeight(showCanvasHeight);
    if(imageStr) {
        fabric.Image.fromURL(imageStr,function(oImg) {
            oImg.set({
                evented: false,
                selectable: false,
            });
            oImg.objType = 'image';
            oImg.imageStr = imageStr;
            oImg.outlineDistance = outlineDist;
            oImg.bleedDistance = bleedBase;
            oImg.realLeft = realLeft;
            oImg.realTop = realTop;
            oImg.realWidth = realWidth;
            oImg.realHeight = realHeight;
            /*var scale = Math.min(diyWorkAreaWidth / imgFactWidth, diyWorkAreaHeight / imgFactHeight);
            oImg.width = imgFactWidth * scale, oImg.height = imgFactHeight * scale;*/
            var scale = Math.min(diyWorkAreaWidth / oImg.width, diyWorkAreaHeight / oImg.height);
            oImg.scaleX = scale;
            oImg.scaleY = scale;
            //oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2; oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2;
            if(svgStr) {
              oImg.left = -realLeft * scale; oImg.top = -realTop * scale;
            } else {
             oImg.left = (diyWorkAreaWidth - oImg.getScaledWidth()) / 2; oImg.top = (diyWorkAreaHeight - oImg.getScaledHeight()) / 2; 
            }
            canvasSource.add(oImg);
            canvasSource.setBackgroundColor("white");
            canvasSource.renderAll();
            setDieCutDemension(realWidth / 300 - expansionDistance / 25.4, realHeight / 300 - expansionDistance / 25.4, outlineDistWidth, outlineDistHeight);
            if(svgStr) {
                let ctx = canvasSource.getContext('2d');
                let imageData = ctx.getImageData(0, 0, 1, 1);
                let pixel = imageData.data;
                let stroke = 'black'
                if(pixel[0] < 44 && pixel[1] < 44 && pixel[2] < 44) {
                  stroke = 'red'
                }
                var drawSvgStr = svgStr.replace(/stroke=\"red\"/g, "stroke=\"" + stroke + "\" stroke-dasharray=\"5,5\"")
                fabric.loadSVGFromString(drawSvgStr, function (objects, options) {
                    var obj = fabric.util.groupSVGElements(objects, options);
                    obj.set({
                        evented: false,
                        selectable: false,
                    });
                    obj.objType = 'svg';
                    obj.svgStr = svgStr;
                    var scale = Math.min(diyWorkAreaWidth / obj.getScaledWidth(), diyWorkAreaHeight / obj.getScaledHeight());
                    obj.scaleX = scale, obj.scaleY = scale;
                    //obj.left = (diyWorkAreaWidth - obj.getScaledWidth()) / 2, obj.top = (diyWorkAreaHeight - obj.getScaledHeight()) / 2;
                    obj.left = -realLeft * scale; obj.top = -realTop * scale;
                    canvasSource.add(obj);
                    
                    var pathData = '';
                    for (var i = 0; i < objects.length; i++) {
                        if (objects[i].type === 'path') {
                            pathData += objects[i].path;
                        }
                    }

                    var clipPath = new fabric.Path(pathData, {
                        left: obj.left,
                        top: obj.top,
                        scaleX: obj.scaleX,
                        scaleY: obj.scaleY,
                        absolutePositioned: true
                    });
                    /*oImg.set({
                        clipPath: clipPath
                    });*/
                    canvasSource.renderAll();
                });
            }
        },{crossOrigin: "anonymous"});
    }
}

function setDieCutDemension(realInchWidth, realInchHeight, outlineDistWidth, outlineDistHeight){
    if($('.demension-h').length == 0){
        $(".canvas-container").append('<div class="demension-h" id="widtho"  style="width:' + (canvasSource.getWidth() - secondBleedWidth * 2 - outlineDistWidth * 2) + 'px;left:'+(secondBleedWidth+outlineDistWidth)+'px;">' +
            '<div class="line"></div>' +
            '<div class="text">' + realInchWidth.toFixed(1) + ' in</div>' +
            '<div class="line"></div>' +
            '</div>');
        $(".canvas-container").append('<div class="demension-v"  id="heightv"  style="height:' + (canvasSource.getHeight() - secondBleedHeight * 2 - outlineDistHeight * 2) + 'px;top:'+(secondBleedHeight+outlineDistHeight)+'px;">' +
            '<div class="line"></div>' +
            '<div class="text">' +  realInchHeight.toFixed(1) + ' in</div>' +
            '<div class="line"></div>' +
            '</div>');
    }
}

function saveDieCut() {
    var istrue=false
    if(!dieCutSuccess){
      $('.designUpload').attr('src', drawImageUrl)
      return true
    }
    $('.cartreloads').find('p').text('Create file+...');
    $('.cartreloads').css('display','block');
    var imageObj, svgObj;
    for (let index = 0; index < canvasSource._objects.length; index++) {
        if(canvasSource._objects[index].objType == 'image'){
            imageObj = canvasSource._objects[index];
        } else if(canvasSource._objects[index].objType == 'svg'){
            svgObj = canvasSource._objects[index];
        }
    }
    if(!imageObj || !svgObj) {
        $('.cartreloads').css('display','none');
        return false;
    }
    //var minScale = Math.min(workAreaWidth / canvasSource.getWidth(), workAreaHeight / canvasSource.getHeight());
    var minScale = Math.min(workAreaWidth / diyWorkAreaWidth, workAreaHeight / diyWorkAreaHeight);
    let data = {
        uniqueId: uniqueId,
        productType: $('.product__titleh1').text(),
        width: inchWidth,
        height: inchHeight,
        diyWidth: diyWorkAreaWidth,
        diyHeight: diyWorkAreaHeight,
        outlineDistance: imageObj.outlineDistance,
        bleedDistance: imageObj.bleedDistance,
        image: {
            realLeft: imageObj.realLeft,
            realTop: imageObj.realTop,
            realWidth: imageObj.realWidth,
            realHeight: imageObj.realHeight,
            preview:canvasSource.toDataURL(),
            url: drawImageUrl,
            factWidth: imgFactWidth,
            factHeight: imgFactHeight,
            str: imageObj.imageStr,
            strWidth: imageObj.width,
            strHeight: imageObj.height,
            left: (imageObj.left * minScale).toFixed(5),
            top: (imageObj.top * minScale).toFixed(5),
            width: (imageObj.getScaledWidth() * minScale).toFixed(5),
            height: (imageObj.getScaledHeight() * minScale).toFixed(5)
        },
        svgInfo: svgObj.svgStr
        //svgInfo: toSvgStr(svgObj)
    };
    $.ajax({
        async:false,
        url: "https://diy.racetopprint.com/racetop-produce/api/aliendiecut/save",
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function(res) {
            res=JSON.parse(res)
            $('.cartreloads').css('display','none');
            if (res.success) {
                $('.cartreloads').find('p').text('Add to cart...');
                if(res.data){
                  $('.designUpload').attr('src',res.data);
                }
                istrue=true
            } else {
                tipShow('Failed to add shopping cart. Please refresh the page and try again')
            }
        },
        error: function(error) {
            $('.cartreloads').css('display','none');
        }
    });
    return istrue;
}

